<template>
  <div class="card pe-3">
    <div class="card-body">
      <h5 class="card-title mb-4">{{ title }}</h5>
      <div class="row">
        <div class="col-12" v-html="description"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    }
  },
}
</script>
